import { RenderMFE } from "@sinch/mfe-helper-react";
import { useEffect, useState, useCallback, type FC } from "react";
import { loadMFE } from "../../../mfe/mfeLoaders";
import { ConditionalWrapper } from "../../ConditionalWrapper";
import { defaultColor } from "./constants";
import { Messages } from "./icons/Messages";
import "@nectary/components/badge";

const inboxMfeId = "inbox-mfe-container";
export const InboxMfe = () => (
  <div style={{ display: "none" }} id={inboxMfeId}>
    <RenderMFE
      basePath={"/"}
      Fallback={() => <></>}
      loadRender={() => loadMFE("container", "inbox")}
    />
  </div>
);

export const InboxIcon: FC = () => {
  const [element, setElement] = useState<HTMLElement | null>(null);
  const [notifications, setNotifications] = useState(0);

  const getNotifications: () => number = useCallback(() => {
    const nrOfNotificationsString =
      element?.getElementsByTagName("sup")[0]?.title;
    const nrOfNotifications = parseInt(nrOfNotificationsString || "", 10);
    if (typeof nrOfNotifications !== "number" || isNaN(nrOfNotifications)) {
      return 0;
    }
    return nrOfNotifications;
  }, [element]);

  useEffect(() => {
    const inboxMfe = document.getElementById(inboxMfeId);
    if (inboxMfe) {
      setElement(inboxMfe);
    }
  }, []);

  useEffect(() => {
    setNotifications(getNotifications());
    const interval = setInterval(() => {
      setNotifications(getNotifications());
    }, 5000);
    return () => clearInterval(interval);
  }, [element, getNotifications]);

  return (
    <>
      <ConditionalWrapper
        shouldWrap={notifications > 0}
        wrapper={(children) => (
          <sinch-badge
            text={notifications > 99 ? "99+" : `${notifications}`}
            size="m"
            mode="circle"
          >
            {children}
          </sinch-badge>
        )}
      >
        <Messages color={defaultColor} />
      </ConditionalWrapper>
    </>
  );
};
